import React from "react";
import { DatePicker, Select, Button } from "antd";
import { useSelector } from "react-redux";

const { Option } = Select;

const Filter = ({ handleSubmit, setFormData, formData }) => {
  const isFormValid = formData.cycleNo && formData.fileType && formData.date;
  const { upload } = useSelector((state) => {
    return {
      upload: state.upload,
    };
  });

  return (
    <div className="flex items-center justify-between gap-4 px-4 py-2">
      <Select
        suffixIcon={<span className="text-lg font-bold text-red-500">*</span>}
        placeholder="Select File Type"
        className="w-full"
        onChange={(value) => setFormData({ ...formData, fileType: value })}
      >
        <Option value="Match">MATCH File</Option>
        <Option value="Unmatch">UNMATCH File</Option>
        <Option value="SAL_File">SAL File</Option>
        <Option value="XML">XML File</Option>
        <Option value="Missing">Missing File</Option>
      </Select>
      <Select
        suffixIcon={<span className="text-lg font-bold text-red-500">*</span>}
        placeholder="Select Cycle No."
        className="w-full"
        onChange={(value) => setFormData({ ...formData, cycleNo: value })}
      >
        {[...Array(8)].map((_, i) => (
          <Option key={i} value={i + 1}>
            Cycle {i + 1}
          </Option>
        ))}
      </Select>
      <DatePicker
        suffixIcon={<span className="text-lg font-bold text-red-500">*</span>}
        className="w-full"
        onChange={(date, dateString) =>
          setFormData({ ...formData, date: dateString })
        }
        placeholder="Select a date"
      />
      {upload?.loading === false &&
      upload?.data === null &&
      upload?.error === null ? (
        <Button
          type="primary"
          onClick={handleSubmit}
          className="bg-blue-500 text-white hover:bg-blue-600 w-full"
          disabled={!isFormValid}
        >
          Submit
        </Button>
      ) : (
        <>
          {upload?.loading === true && (
            <span className="animate-pulse text-lg text-yellow-600">
              File uploading...
            </span>
          )}
          {upload?.loading === false && upload?.error !== null && (
            <span className="text-lg text-red-600">
              {upload?.error?.response?.message ||
                upload?.error?.response ||
                upload?.error}
            </span>
          )}
          {upload?.loading === false && upload?.status === true && (
            <span className="text-lg text-green-600">
              File uploaded successfully
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default Filter;

// import React, { useState } from "react";
// import { DatePicker, Select, Button } from "antd";
// import DnD from "./DnD";

// const { Option } = Select;

// const Filter = ({ handleSubmit, setFormData, formData }) => {
//   const isFormValid = formData.cycleNo && formData.fileType && formData.date;

//   return (
//     <div className="flex items-center gap-4 px-4 py-2">
//       <Select
//         placeholder="Select File Type"
//         className="w-50"
//         onChange={(value) => setFormData({ ...formData, fileType: value })}
//       >
//         <Option value="Match">MATCH File</Option>
//         <Option value="Unmatch">UNMATCH File</Option>
//         <Option value="SAL_File">SAL File</Option>
//         <Option value="XML">XML File</Option>
//       </Select>
//       <Select
//         placeholder="Select Cycle No."
//         className="w-48"
//         onChange={(value) => setFormData({ ...formData, cycleNo: value })}
//       >
//         {[...Array(8)].map((_, i) => (
//           <Option key={i} value={i + 1}>
//             Cycle {i + 1}
//           </Option>
//         ))}
//       </Select>
//       <DatePicker
//         className="w-48"
//         onChange={(date, dateString) => setFormData({ ...formData, date: dateString })}
//         placeholder="Select a date"
//       />
//       <Button
//         type="primary"
//         onClick={handleSubmit}
//         className="bg-blue-500 text-white hover:bg-blue-600"
//         disabled={!isFormValid}
//       >
//         Submit
//       </Button>
//     </div>
//   );
// };

// export default Filter;
